<template xmlns:v-on="http://www.w3.org/1999/xhtml">
  <div id="templatePane">
    <div class="hero-section" style="background-image:url(/static/images/hero-broken.png)">
      <div class="hero-section-text row column">
        <h1>Oops, looks like we need to fix something</h1>
      </div>
    </div>
    <section id="mainContent" class="row column">
      <h2>Something isn't quite right at our end of the line</h2>
      <p>It looks like you've been invited, but for some reason we're unable to sign you up at the moment.  But don't worry, you don't have to do anything as we have let our support teams know what's happened so they can investigate.</p>
      
      <p>If you've access to the BT intranet, head to FixIT where we have <a href="https://fixit.bt.com/pages/browsebysubject.aspx?contentcenter=Workplace%20by%20Facebook">lots of articles</a> that may be able to help.</p>
    </section>
  </div>
</template>

<script>
var ES6Promise = require("es6-promise")
ES6Promise.polyfill()
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)
import {fixitContentCentre} from '../commonError'

export default {
  name: 'ErrorWorkplaceNotInvited',
  title: "Workplace - Please wait for your invitation",
  data: function() {
    return {
      fixitContentCentre: fixitContentCentre
    }
  }
}

</script>
